var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V47H47V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0208 23.5C46.0208 35.938 35.938 46.0208 23.5 46.0208C11.0621 46.0208 0.979167 35.938 0.979167 23.5C0.979167 11.0621 11.0621 0.979167 23.5 0.979167C35.938 0.979167 46.0208 11.0621 46.0208 23.5Z",
    fill: "#0088CC",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9536 15.5268H30.1303C30.634 15.5268 31.0537 15.6108 31.5572 15.8625C32.1447 16.1143 32.4803 16.534 32.6482 16.8697C32.6482 16.8697 32.6482 16.9536 32.7322 16.9536C32.984 17.3733 33.1518 17.8768 33.1518 18.4643C33.1518 18.9679 33.0678 19.4715 32.7322 19.975L24.4232 34.2428C24.2553 34.5787 23.9197 34.7465 23.5 34.7465C23.1643 34.7465 22.8287 34.5787 22.5768 34.2428L14.4357 19.975C14.2679 19.6393 13.9322 19.2197 13.9322 18.5483C13.8482 17.9608 14.0161 17.4572 14.2679 16.9536C14.5197 16.45 14.9393 16.0304 15.5268 15.8625C16.0304 15.5268 16.6179 15.5268 16.9536 15.5268ZM22.4928 17.5411H16.9536C16.6179 17.5411 16.45 17.5411 16.3661 17.625C16.1982 17.709 16.1143 17.7929 16.0304 17.9608C15.9465 18.0447 15.9465 18.2125 15.9465 18.3804C15.9465 18.4643 16.0304 18.5483 16.1982 18.884L22.4928 29.7947V17.5411ZM24.5072 17.5411V29.8787L30.8857 18.884C30.9697 18.7161 30.9697 18.5483 30.9697 18.3804C30.9697 18.2125 30.9697 18.0447 30.8857 17.9608C30.8018 17.8768 30.8018 17.7929 30.7178 17.7929L30.634 17.709C30.4662 17.625 30.2982 17.625 30.0465 17.625H24.5072V17.5411Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.3dfdea45594904842ea40a42d3c6418d.svg";
export { ForwardRef as ReactComponent };